import axios from "axios";
import { addMessage } from "conten/mensajes/MessagesActions";
import {
  CUENTA_GRABAR,
  grabarCuentaSuccess,
  grabarCuentaError,
  CUENTA_LISTAR,
  listarCuentaSuccess,
  listarCuentaError,
  CUENTA_PARA_EDITAR,
  CUENTA_USUARIO_LISTAR,
  listarCuentaUsuarioSuccess,
  listarCuentaUsuarioError,
  LISTAR_MAX_PLACA_EXENTA,
  listarMaxPlacaExentaSuccess,
  listarMaxPlacaExentaError,
} from "conten/cuentas/CuentaActions";
import CuentaApi from "conten/cuentas/CuentaApiClient";
import { ofType } from "redux-observable";
import { from, Observable } from "rxjs";
import { mergeMap, filter } from "rxjs/operators";
import {
  OK,
  ERROR,
  apiTimeout,
  ID_PERFIL,
  PERFIL_CUENTAS,
} from "config/general/Configuracion";
import { CUENTA_LISTAR_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR, GRABAR_LIMITE_MAX_PERFILES_AUXILIAR, GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO, GRABAR_LIMITE_MAX_PERFILES_PROMOTOR, GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR, GRABAR_LIMITE_MAX_PERFILES_VISOR, GRABAR_LIMITE_MAX_ZONAS, GRABAR_LIMITE_PLACA_EXENTA, grabarLimiteMaxPerfilesAdministradorError, grabarLimiteMaxPerfilesAdministradorSuccess, grabarLimiteMaxPerfilesAuxiliarError, grabarLimiteMaxPerfilesAuxiliarSuccess, grabarLimiteMaxPerfilesMunicipioError, grabarLimiteMaxPerfilesMunicipioSuccess, grabarLimiteMaxPerfilesPromotorError, grabarLimiteMaxPerfilesPromotorSuccess, grabarLimiteMaxPerfilesSupervisorError, grabarLimiteMaxPerfilesSupervisorSuccess, grabarLimiteMaxPerfilesVisorError, grabarLimiteMaxPerfilesVisorSuccess, grabarLimiteMaxZonasError, grabarLimiteMaxZonasSuccess, grabarLimitePlacaExentaError, grabarLimitePlacaExentaSuccess, listarCuentaEnriquecidaSuccess } from "./CuentaActions";

export const listarCuentaUsuario = (action$, state$) =>
  action$.pipe(
    ofType(CUENTA_USUARIO_LISTAR),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          if (localStorage[ID_PERFIL] === PERFIL_CUENTAS) {
            axios.defaults.timeout = apiTimeout;
            axios(CuentaApi.listarCuentaUsuario())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  obs.next(listarCuentaUsuarioSuccess(response.data));
                  obs.complete();
                  action.onSuccess(OK, response.data);
                }
              })
              .catch((error) => {
                obs.next(listarCuentaUsuarioError(error));
                var mensajeError = "Hubo un problema: " + error.message;
                if (error && error.response && error.response.data) {
                  mensajeError = error.response.data;
                }
                action.onSuccess(ERROR, mensajeError + "");
                obs.next(
                  addMessage({ variant: "error", message: mensajeError + "" })
                );
                obs.complete();
              });
          } else {
            obs.next(
              listarCuentaUsuarioSuccess(
                state$.value.cuentaState.cuentasDesdeAcceso
              )
            );
            obs.complete();
            action.onSuccess(OK, state$.value.cuentaState.cuentasDesdeAcceso);
          }
        })
    )
  );

export const editarCuenta = (action$, state$) =>
  action$.pipe(
    ofType(CUENTA_PARA_EDITAR),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          setTimeout(() => {
            if (action.onSuccess) {
              action.onSuccess(OK, "Listo para editar"); //clave para darle tiempo al sistema de actualizar bien el estado
            }
          }, 1000);
          obs.complete();
        })
    )
  );

export const listarCuenta = (action$, state$) =>
  action$.pipe(
    ofType(CUENTA_LISTAR),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(CuentaApi.listarCuenta(action.paginacion))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(listarCuentaSuccess(response.data));
                obs.complete();
                action.onSuccess(OK, response.data);
              }
            })
            .catch((error) => {
              obs.next(listarCuentaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const grabarCuenta = (action$, state$) =>
  action$.pipe(
    ofType(CUENTA_GRABAR),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(CuentaApi.grabarCuenta(action.cuenta))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(grabarCuentaSuccess(response));
                action.onSuccess(OK, response.data);
                obs.complete();
              }
            })
            .catch((error) => {
              obs.next(grabarCuentaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const listarMaxPlacaExenta = (action$, state$) =>
  action$.pipe(
    ofType(LISTAR_MAX_PLACA_EXENTA),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          if (localStorage[ID_PERFIL] === PERFIL_CUENTAS) {
            axios.defaults.timeout = apiTimeout;
            axios(CuentaApi.listarMaxPlacaExenta(action.cuenta))
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  obs.next(listarMaxPlacaExentaSuccess(response.data));
                  (action.onSuccess || (() => { }))(OK, response.data);
                } else {
                  const mensajeError = response.statusText || "Respuesta inesperada";
                  obs.next(addMessage({ variant: "error", message: mensajeError }));
                  (action.onSuccess || (() => { }))(ERROR, mensajeError);
                }
                obs.complete();
              })
              .catch((error) => {
                const mensajeError = error?.response?.data || error.message;
                obs.next(listarMaxPlacaExentaError(error));
                obs.next(addMessage({ variant: "error", message: mensajeError }));
                (action.onSuccess || (() => { }))(ERROR, mensajeError);
                obs.complete();
              });
          } else {
            const localData = state$.value.cuentaState.maxPlacaExenta;
            obs.next(listarMaxPlacaExentaSuccess(localData));
            (action.onSuccess || (() => { }))(OK, localData);
            obs.complete();
          }
        })
    )
  );

export const enriquecerCuentasEpic = (action$) =>
  action$.pipe(
    ofType(CUENTA_LISTAR_SUCCESS),
    mergeMap((action) => {
      const cuentas = action.respuestaServidor.cuentas;

      const peticiones = cuentas.map(async (cuenta) => {
        if (cuenta.id === "AdministradorCuentas") {
          return {
            ...cuenta,
            max_placa_exenta: cuenta.max_placa_exenta ?? null,
            max_zonas: cuenta.max_zonas ?? null,
            max_perfiles_administrador: cuenta.max_perfiles_administrador ?? null,
            max_perfiles_supervisor: cuenta.max_perfiles_supervisor ?? null,
            max_perfiles_auxiliar: cuenta.max_perfiles_auxiliar ?? null,
            max_perfiles_promotor: cuenta.max_perfiles_promotor ?? null,
            max_perfiles_municipio: cuenta.max_perfiles_municipio ?? null,
            max_perfiles_visor: cuenta.max_perfiles_visor ?? null,
          };
        }

        const cuentaActualizada = { ...cuenta };

        const tareas = [
          {
            key: "max_placa_exenta",
            fn: CuentaApi.listarMaxPlacaExenta,
            errorKey: "errorMaxPlacaExenta",
          },
          {
            key: "max_zonas",
            fn: CuentaApi.listarMaxZonas,
            errorKey: "errorMaxZonas",
          },
          {
            key: "max_perfiles_administrador",
            fn: CuentaApi.listarMaxPerfilesAdministrador,
            errorKey: "errorMaxPerfilesAdministrador",
          },
          {
            key: "max_perfiles_supervisor",
            fn: CuentaApi.listarMaxPerfilesSupervisor,
            errorKey: "errorMaxPerfilesSupervisor",
          },
          {
            key: "max_perfiles_auxiliar",
            fn: CuentaApi.listarMaxPerfilesAuxiliar,
            errorKey: "errorMaxPerfilesAuxiliar",
          },
          {
            key: "max_perfiles_promotor",
            fn: CuentaApi.listarMaxPerfilesPromotor,
            errorKey: "errorMaxPerfilesPromotor",
          },
          {
            key: "max_perfiles_municipio",
            fn: CuentaApi.listarMaxPerfilesMunicipio,
            errorKey: "errorMaxPerfilesMunicipio",
          },
          {
            key: "max_perfiles_visor",
            fn: CuentaApi.listarMaxPerfilesVisor,
            errorKey: "errorMaxPerfilesVisor",
          },
        ];

        for (const tarea of tareas) {
          if (cuentaActualizada[tarea.key] === undefined) {
            try {
              const res = await axios(tarea.fn(cuenta.id));
              cuentaActualizada[tarea.key] = res.data;
            } catch (error) {
              console.error(`❌ Error consultando ${tarea.key} para cuenta ${cuenta.id}:`, error);
              cuentaActualizada[tarea.key] = null;
              cuentaActualizada[tarea.errorKey] = true;
            }
          }
        }

        return cuentaActualizada;
      });

      return from(
        Promise.allSettled(peticiones).then((resultados) => {
          const cuentasFinales = resultados
            .filter((res) => res.status === "fulfilled")
            .map((res) => res.value);

          return listarCuentaEnriquecidaSuccess({
            cuentas: cuentasFinales,
            paginacion: action.respuestaServidor.paginacion,
          });
        })
      );
    })
  );

export const grabarLimitePlacaExenta = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_PLACA_EXENTA),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(CuentaApi.grabarLimitePlacaExenta(action.cuenta, action.valor))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(grabarLimitePlacaExentaSuccess(response));
                action.onSuccess(OK, response.data);
                obs.complete();
              }
            })
            .catch((error) => {
              obs.next(grabarLimitePlacaExentaError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const grabarLimiteMaxZonas = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_ZONAS),
    mergeMap(
      (action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(CuentaApi.grabarLimiteMaxZonas(action.cuenta, action.valor))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(grabarLimiteMaxZonasSuccess(response));
                action.onSuccess(OK, response.data);
                obs.complete();
              }
            })
            .catch((error) => {
              obs.next(grabarLimiteMaxZonasError(error));
              var mensajeError = "Hubo un problema: " + error.message;
              if (error && error.response && error.response.data) {
                mensajeError = error.response.data;
              }
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(
                addMessage({ variant: "error", message: mensajeError + "" })
              );
              obs.complete();
            });
        })
    )
  );

export const grabarLimiteMaxPerfilesAdministrador = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR),
    mergeMap((action) =>
      new Observable((obs) => {
        axios.defaults.timeout = apiTimeout;
        axios(CuentaApi.grabarLimiteMaxPerfilesAdministrador(action.cuenta, action.valor))
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              obs.next(grabarLimiteMaxPerfilesAdministradorSuccess(response));
              action.onSuccess(OK, response.data);
              obs.complete();
            }
          })
          .catch((error) => {
            obs.next(grabarLimiteMaxPerfilesAdministradorError(error));
            const mensajeError = error?.response?.data || error.message;
            action.onSuccess(ERROR, mensajeError + "");
            obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
            obs.complete();
          });
      })
    )
  );

export const grabarLimiteMaxPerfilesSupervisor = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR),
    mergeMap((action) =>
      new Observable((obs) => {
        axios.defaults.timeout = apiTimeout;
        axios(CuentaApi.grabarLimiteMaxPerfilesSupervisor(action.cuenta, action.valor))
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              obs.next(grabarLimiteMaxPerfilesSupervisorSuccess(response));
              action.onSuccess(OK, response.data);
              obs.complete();
            }
          })
          .catch((error) => {
            obs.next(grabarLimiteMaxPerfilesSupervisorError(error));
            const mensajeError = error?.response?.data || error.message;
            action.onSuccess(ERROR, mensajeError + "");
            obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
            obs.complete();
          });
      })
    )
  );


export const grabarLimiteMaxPerfilesAuxiliar = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_PERFILES_AUXILIAR),
    mergeMap((action) =>
      new Observable((obs) => {
        axios.defaults.timeout = apiTimeout;
        axios(CuentaApi.grabarLimiteMaxPerfilesAuxiliar(action.cuenta, action.valor))
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              obs.next(grabarLimiteMaxPerfilesAuxiliarSuccess(response));
              action.onSuccess(OK, response.data);
              obs.complete();
            }
          })
          .catch((error) => {
            obs.next(grabarLimiteMaxPerfilesAuxiliarError(error));
            const mensajeError = error?.response?.data || error.message;
            action.onSuccess(ERROR, mensajeError + "");
            obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
            obs.complete();
          });
      })
    )
  );


export const grabarLimiteMaxPerfilesMunicipio = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO),
    mergeMap((action) =>
      new Observable((obs) => {
        axios.defaults.timeout = apiTimeout;
        axios(CuentaApi.grabarLimiteMaxPerfilesMunicipio(action.cuenta, action.valor))
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              obs.next(grabarLimiteMaxPerfilesMunicipioSuccess(response));
              action.onSuccess(OK, response.data);
              obs.complete();
            }
          })
          .catch((error) => {
            obs.next(grabarLimiteMaxPerfilesMunicipioError(error));
            const mensajeError = error?.response?.data || error.message;
            action.onSuccess(ERROR, mensajeError + "");
            obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
            obs.complete();
          });
      })
    )
  );


export const grabarLimiteMaxPerfilesVisor = (action$, state$) =>
  action$.pipe(
    ofType(GRABAR_LIMITE_MAX_PERFILES_VISOR),
    mergeMap((action) =>
      new Observable((obs) => {
        axios.defaults.timeout = apiTimeout;
        axios(CuentaApi.grabarLimiteMaxPerfilesVisor(action.cuenta, action.valor))
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              obs.next(grabarLimiteMaxPerfilesVisorSuccess(response));
              action.onSuccess(OK, response.data);
              obs.complete();
            }
          })
          .catch((error) => {
            obs.next(grabarLimiteMaxPerfilesVisorError(error));
            const mensajeError = error?.response?.data || error.message;
            action.onSuccess(ERROR, mensajeError + "");
            obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
            obs.complete();
          });
      })
    )
  );


  export const grabarLimiteMaxPerfilesPromotor = (action$, state$) =>
    action$.pipe(
      ofType(GRABAR_LIMITE_MAX_PERFILES_PROMOTOR),
      mergeMap((action) =>
        new Observable((obs) => {
          axios.defaults.timeout = apiTimeout;
          axios(CuentaApi.grabarLimiteMaxPerfilesPromotor(action.cuenta, action.valor))
            .then((response) => {
              if (response.status === 200 || response.status === 201) {
                obs.next(grabarLimiteMaxPerfilesPromotorSuccess(response));
                action.onSuccess(OK, response.data);
                obs.complete();
              }
            })
            .catch((error) => {
              obs.next(grabarLimiteMaxPerfilesPromotorError(error));
              const mensajeError = error?.response?.data || error.message;
              action.onSuccess(ERROR, mensajeError + "");
              obs.next(addMessage({ variant: "error", message: mensajeError + "" }));
              obs.complete();
            });
        })
      )
    );
  






